/**
 * API统一导出模块
 * 集中导出所有API接口，便于统一管理
 */

import healthApi from './modules/health'
import user from './modules/user'
import unit from './modules/unit'
import role from './modules/role'
import permission from './modules/permission'
import * as contracts from './modules/contracts'
import orders from './modules/orders'
import settlements from './modules/settlement'
import settlementAttachments from './modules/settlement-attachment'
import invoices from './modules/invoice'
import statistics from './modules/statistics'

// 统一导出所有API模块
export default {
  health: healthApi,
  user,
  unit,
  role,
  permission,
  contracts,
  orders,
  settlements,
  settlementAttachments,
  invoices,
  statistics
} 